import { useState } from "react";
import { SensorKitModel } from "@/sensorKits/sensorKit";
import { SensorKitFilters } from "@/sensorKits/api";

export const useSensorKitHealthFilters = () => {
  const [modelFilter, setModelFilter] = useState<SensorKitModel | "">("refrigerant");
  const [versionFilter, setVersionFilter] = useState<string[]>([]);
  const [hasCurrentInstallationFilter, setHasCurrentInstallationFilter] = useState<boolean | undefined>(true);

  const handleModelChange = (value: string) => {
    setModelFilter(value as SensorKitModel | "");
    // Reset version filter when model changes
    setVersionFilter([]);
  };

  const filters: SensorKitFilters = {
    config_model: modelFilter || undefined,
    config_versions: versionFilter.length > 0 ? versionFilter : undefined,
    has_current_installation: hasCurrentInstallationFilter,
  };

  return {
    modelFilter,
    setModelFilter: handleModelChange,
    versionFilter,
    setVersionFilter,
    hasCurrentInstallationFilter,
    setHasCurrentInstallationFilter,
    filters,
  };
};
